{
  "name": "tef-coms4cs4p",
  "version": "1.2.1",
  "description": "Micro-Frontend for Customer Service for kernel consents (aka 4th-platform)",
  "keywords": [
    "coms",
    "kernel",
    "micro-frontend",
    "tef-coms4cs4p",
    "web component"
  ],
  "license": "INTERNAL USE ONLY",
  "author": {
    "name": "Telefónica Germany GmbH & Co. OHG",
    "email": "u672-coms@telefonica.com"
  },
  "repository": {
    "type": "git",
    "url": "https://mucsggit02.sg.de.pri.o2.com/consent-management/consent-management.git",
    "directory": "micro-frontend-4cs-4p"
  },
  "files": [
    "dist/**/*"
  ],
  "type": "module",
  "module": "dist/tef-coms4cs4p.js",
  "types": "dist/typings.d.ts",
  "publishConfig": {
    "registry": "https://art02.sg.de.pri.o2.com/artifactory/api/npm/npm-local/"
  },
  "scripts": {
    "install:ci": "npm ci --no-fund --no-audit",
    "postinstall:ci": "echo '> npm ci in dependency projects:';node --eval 'console.log(require(\"./tsconfig.json\").references.map(r=>r.path).join(\"\\n\"));' | xargs -I{} sh -c 'cd {}; pwd; npm run install:ci'",
    "dev": "tsx ./scripts/esbuild/dev.ts",
    "dev:docker": "npm run build:docker && npm run dev",
    "build": "npm run build:prebuild && npm run build:build && npm run build:docs",
    "build:docker": "npm run build:build && npm run build:docs",
    "build:build": "tsx ./scripts/esbuild/build.ts",
    "build:docs": "tsx ./scripts/create-docs.ts",
    "build:serve": "npm run build && npx -y serve -l 4500 dist",
    "build:prebuild": "rm -rf dist && rm -rf build && mkdir -p dist && mkdir -p build",
    "preversion": "npm run lint && npm test",
    "lint": "npm run lint:lit-analyzer && npm run lint:eslint",
    "lint:eslint": "eslint .",
    "lint:lit-analyzer": "lit-analyzer",
    "lint:fix": "eslint . --fix",
    "test": "npm run test:unit",
    "test:unit": "vitest run",
    "test:verbose": "vitest run --reporter verbose",
    "test:ci": "npm run lint && CI=true npm test && npm run test:zipcov",
    "test:zipcov": "zip lcov.zip ./coverage-unit/lcov.info ./coverage-browser/lcov.info"
  },
  "dependencies": {
    "lit": "^3.3.2",
    "normalize-url": "^9.0.0"
  },
  "devDependencies": {
    "@jgoz/esbuild-plugin-typecheck": "^4.0.4",
    "@open-wc/testing-helpers": "^3.0.1",
    "@testing-library/dom": "^10.4.1",
    "@types/markdown-it": "^14.1.2",
    "@types/markdown-it-attrs": "^4.1.3",
    "@types/markdown-it-container": "^4.0.0",
    "@types/markdown-it-emoji": "^3.0.1",
    "@types/mustache": "^4.2.6",
    "@types/node": "^24.10.0",
    "@typescript-eslint/eslint-plugin": "^7.5.0",
    "@typescript-eslint/parser": "^7.5.0",
    "@vitest/coverage-v8": "^4.1.1",
    "deepmerge-ts": "^7.1.5",
    "esbuild": "^0.28.0",
    "esbuild-plugin-copy": "^2.1.1",
    "eslint": "^8.57.1",
    "eslint-config-airbnb-base": "^15.0.0",
    "eslint-config-airbnb-typescript": "^18.0.0",
    "eslint-import-resolver-typescript": "^3.7.0",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-lit": "^1.15.0",
    "eslint-plugin-promise": "^7.2.1",
    "eslint-plugin-simple-import-sort": "^12.1.0",
    "eslint-plugin-sonarjs": "^4.0.1",
    "fetch-mock": "^12.6.0",
    "happy-dom": "^20.8.8",
    "jose": "^6.1.3",
    "lit-analyzer": "^2.0.3",
    "markdown-it": "^14.1.1",
    "markdown-it-anchor": "^9.2.0",
    "markdown-it-attrs": "^4.3.1",
    "markdown-it-container": "^4.0.0",
    "markdown-it-emoji": "^3.0.0",
    "markdown-it-toc-done-right": "^4.2.0",
    "mustache": "^4.2.0",
    "ts-lit-plugin": "^2.0.2",
    "ts-node": "^10.9.2",
    "ts-patch": "^3.3.0",
    "tsx": "^4.21.0",
    "typescript": "^5.9.3",
    "typescript-transform-paths": "^3.5.6",
    "vite": "^8.0.3",
    "vitest": "^4.1.1",
    "vue": "^3.5.35",
    "vuetify": "^4.1.0"
  },
  "overrides": {
    "@typescript-eslint/typescript-estree": "^8.44.0",
    "esbuild-plugin-lit-css": {
      "esbuild": "^0.27.3"
    }
  },
  "title": "COMS Micro-Frontend for Customer Service for kernel consents (4p)"
}
